const BaseConstants = {
    'ACTIVE': 'ACTIVE',
    'INACTIVE': 'INACTIVE',

    'CONNECTED': 'CONNECTED',
    'DISCONNECTED': 'DISCONNECTED',

    'LOGIN': 'LOGIN',
    'LOGIN_LOADED': 'LOGIN_LOADED',
    'LOGIN_ERROR': 'LOGIN_ERROR',
    'REFRESH_TOKENS': 'REFRESH_TOKENS',

    'REGISTER': 'REGISTER',
    'REGISTER_LOADED': 'REGISTER_LOADED',
    'REGISTER_ERROR': 'REGISTER_ERROR',

    'STARTUP': 'STARTUP',
    'STARTUP_LOADED': 'STARTUP_LOADED',
    'STARTUP_ERROR': 'STARTUP_ERROR',

    'LOGOUT': 'LOGOUT',
    'CLEAR_USER': 'CLEAR_USER',
    'REFRESH': 'REFRESH',

    'CONFIRM_EMAIL': 'CONFIRM_EMAIL',
    'CONFIRM_EMAIL_ERROR': 'CONFIRM_EMAIL_ERROR',
    'CONFIRM_EMAIL_LOADED': 'CONFIRM_EMAIL_LOADED',


    'UPDATE_USER': 'UPDATE_USER',
    'UPDATE_USER_ERROR': 'UPDATE_USER_ERROR',
    'UPDATE_USER_LOADED': 'UPDATE_USER_LOADED',

    'LOGIN_WITH_TOKEN': 'LOGIN_WITH_TOKEN',
    'LOGIN_WITH_TOKEN_LOADED': 'LOGIN_WITH_TOKEN_LOADED',
    'LOGIN_WITH_TOKEN_ERROR': 'LOGIN_WITH_TOKEN_ERROR',

};

const BaseActions = {
    connected() {
        return {
            type: Actions.CONNECTED,
        };
    },
    disconnected() { // when the device goes offline
        return {
            type: Actions.DISCONNECTED,
            // todo: maybe store last online
        };
    },
    active() {
        return {
            type: Actions.ACTIVE,
        };
    },
    inactive() { // when the app goes out of focus
        return {
            type: Actions.INACTIVE,
            // todo: maybe store last online
        };
    },
    refresh() { // force the app to refresh data
        return {
            type: Actions.REFRESH,
        };
    },
    login(data, callbacks) {
        return {
            type: Actions.LOGIN,
            data,
            ...callbacks,
        };
    },
    // LOGIN
    loginLoaded: (user) => {
        return { type: Actions.LOGIN_LOADED, user };
    },
    loginError: (error) => {
        return { type: Actions.LOGIN_ERROR, error };
    },
    // STARTUP
    startup(data, callbacks) {
        return {
            type: Actions.STARTUP,
            data,
            ...callbacks,
        };
    },
    // REGISTER
    register(data, callbacks) {
        return {
            type: Actions.REGISTER,
            data,
            ...callbacks,
        };
    },
    updateUser(data, callbacks = {}) {
        return {
            type: Actions.UPDATE_USER,
            data,
            ...callbacks,
        };
    },
    confirmEmail(data, callbacks = {}) {
        return {
            type: Actions.CONFIRM_EMAIL,
            data,
            ...callbacks,
        };
    },
    registerLoaded: (user) => {
        return { type: Actions.REGISTER_LOADED, user };
    },
    registerError: (error) => {
        return { type: Actions.REGISTER_ERROR, error };
    },
    logout(callbacks) {
        return {
            type: Actions.LOGOUT,
            ...callbacks,
        };
    },
    loginWithToken(token, callbacks) {
        return {
            type: Actions.LOGIN_WITH_TOKEN,
            token,
            ...callbacks,
        };
    },
    loginWithTokenLoaded: (user) => {
        return { type: Actions.LOGIN_WITH_TOKEN_LOADED, user };
    },
    loginWithTokenError: (error) => {
        return { type: Actions.LOGIN_WITH_TOKEN_ERROR, error };
    },
};

export const Actions = global.Actions = Object.assign({}, BaseConstants, {
    'CHECK_SUBSCRIPTION': 'CHECK_SUBSCRIPTION',
    'CHECK_SUBSCRIPTION_ERROR': 'CHECK_SUBSCRIPTION_ERROR',
    'CHECK_SUBSCRIPTION_LOADED': 'CHECK_SUBSCRIPTION_LOADED',

    'VERIFY_RECEIPT': 'VERIFY_RECEIPT',
    'VERIFY_RECEIPT_ERROR': 'VERIFY_RECEIPT_ERROR',
    'VERIFY_RECEIPT_LOADED': 'VERIFY_RECEIPT_LOADED',

    'GET_PLANS': 'GET_PLANS',
    'GET_PLANS_ERROR': 'GET_PLANS_ERROR',
    'GET_PLANS_LOADED': 'GET_PLANS_LOADED',

    'CREATE_SUBSCRIPTION': 'CREATE_SUBSCRIPTION',
    'CREATE_SUBSCRIPTION_ERROR': 'CREATE_SUBSCRIPTION_ERROR',
    'CREATE_SUBSCRIPTION_LOADED': 'CREATE_SUBSCRIPTION_LOADED',

    'GET_NEXT_SUBSCRIPTION': 'GET_NEXT_SUBSCRIPTION',
    'GET_NEXT_SUBSCRIPTION_ERROR': 'GET_NEXT_SUBSCRIPTION_ERROR',
    'GET_NEXT_SUBSCRIPTION_LOADED': 'GET_NEXT_SUBSCRIPTION_LOADED',

    'UPDATE_NEXT_SUBSCRIPTION': 'UPDATE_NEXT_SUBSCRIPTION',
    'UPDATE_NEXT_SUBSCRIPTION_ERROR': 'UPDATE_NEXT_SUBSCRIPTION_ERROR',
    'UPDATE_NEXT_SUBSCRIPTION_LOADED': 'UPDATE_NEXT_SUBSCRIPTION_LOADED',

    'CANCEL_SUBSCRIPTION': 'CANCEL_SUBSCRIPTION',
    'CANCEL_SUBSCRIPTION_ERROR': 'CANCEL_SUBSCRIPTION_ERROR',
    'CANCEL_SUBSCRIPTION_LOADED': 'CANCEL_SUBSCRIPTION_LOADED',

    'GET_CURRENCY': 'GET_CURRENCY',
    'GET_CURRENCY_ERROR': 'GET_CURRENCY_ERROR',
    'GET_CURRENCY_LOADED': 'GET_CURRENCY_LOADED',

    'GET_COUNTRY': 'GET_COUNTRY',
    'GET_COUNTRY_ERROR': 'GET_COUNTRY_ERROR',
    'GET_COUNTRY_LOADED': 'GET_COUNTRY_LOADED',

    'GET_COUPONS': 'GET_COUPONS',
    'GET_COUPONS_ERROR': 'GET_COUPONS_ERROR',
    'GET_COUPONS_LOADED': 'GET_COUPONS_LOADED',

    'GET_COUPON': 'GET_COUPON',
    'GET_COUPON_ERROR': 'GET_COUPON_ERROR',
    'GET_COUPON_LOADED': 'GET_COUPON_LOADED',
    'CLEAR_COUPON': 'CLEAR_COUPON',

    'GET_COUPON_APPLIED': 'GET_COUPON_APPLIED',
    'GET_COUPON_APPLIED_ERROR': 'GET_COUPON_APPLIED_ERROR',
    'GET_COUPON_APPLIED_LOADED': 'GET_COUPON_APPLIED_LOADED',

    'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS': 'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS',
    'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_ERROR': 'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_ERROR',
    'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_LOADED': 'SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_LOADED',

    'USER_LOADING': 'USER_LOADING',
// END OF ACTION_STRINGS
});

export const AppActions = global.AppActions = Object.assign({}, BaseActions, {
    checkSubscription(callbacks = {}) {
        return { type: Actions.CHECK_SUBSCRIPTION, ...callbacks };
    },
    checkSubscriptionLoaded(hasSubscription) {
        return { type: Actions.CHECK_SUBSCRIPTION_LOADED, hasSubscription };
    },
    checkSubscriptionError(error) {
        return { type: Actions.CHECK_SUBSCRIPTION_ERROR, error };
    },
    verifyReceipt(receipt, callbacks = {}) {
        return { type: Actions.VERIFY_RECEIPT, receipt, ...callbacks };
    },
    verifyReceiptLoaded() {
        return { type: Actions.VERIFY_RECEIPT_LOADED };
    },
    verifyReceiptError(error) {
        return { type: Actions.VERIFY_RECEIPT_ERROR, error };
    },
    getPlans(callbacks = {}) {
        return { type: Actions.GET_PLANS, ...callbacks };
    },
    getPlansLoaded() {
        return { type: Actions.GET_PLANS_LOADED };
    },
    getPlansError(error) {
        return { type: Actions.GET_PLANS_ERROR, error };
    },
    createSubscription(intent, callbacks = {}) {
        return { type: Actions.CREATE_SUBSCRIPTION, data: intent, ...callbacks };
    },
    createSubscriptionLoaded(subscription) {
        return { type: Actions.CREATE_SUBSCRIPTION_LOADED, subscription };
    },
    createSubscriptionError(error) {
        return { type: Actions.CREATE_SUBSCRIPTION_ERROR, error };
    },
    getNextSubscription(callbacks = {}) {
        return { type: Actions.GET_NEXT_SUBSCRIPTION, ...callbacks };
    },
    getNextSubscriptionLoaded() {
        return { type: Actions.GET_NEXT_SUBSCRIPTION_LOADED };
    },
    getNextSubscriptionError(error) {
        return { type: Actions.GET_NEXT_SUBSCRIPTION_ERROR, error };
    },
    updateNextSubscription(intent, callbacks = {}) {
        return { type: Actions.UPDATE_NEXT_SUBSCRIPTION, data: intent, ...callbacks };
    },
    updateNextSubscriptionLoaded() {
        return { type: Actions.UPDATE_NEXT_SUBSCRIPTION_LOADED };
    },
    updateNextSubscriptionError(error) {
        return { type: Actions.UPDATE_NEXT_SUBSCRIPTION_ERROR, error };
    },
    cancelSubscription(callbacks = {}) {
        return { type: Actions.CANCEL_SUBSCRIPTION, ...callbacks };
    },
    cancelSubscriptionLoaded() {
        return { type: Actions.CANCEL_SUBSCRIPTION_LOADED };
    },
    cancelSubscriptionError(error) {
        return { type: Actions.CANCEL_SUBSCRIPTION_ERROR, error };
    },
    getCurrency(callbacks = {}) {
        return { type: Actions.GET_CURRENCY, ...callbacks };
    },
    getCurrencyLoaded() {
        return { type: Actions.GET_CURRENCY_LOADED };
    },
    getCurrencyError(error) {
        return { type: Actions.GET_CURRENCY_ERROR, error };
    },
    getCountry(callbacks = {}) {
        return { type: Actions.GET_COUNTRY, ...callbacks };
    },
    getCountryLoaded() {
        return { type: Actions.GET_COUNTRY_LOADED };
    },
    getCountryError(error) {
        return { type: Actions.GET_COUNTRY_ERROR, error };
    },
    getCoupons(callbacks = {}) {
        return { type: Actions.GET_COUPONS, ...callbacks };
    },
    getCouponsLoaded() {
        return { type: Actions.GET_COUPONS_LOADED };
    },
    getCouponsError(error) {
        return { type: Actions.GET_COUPONS_ERROR, error };
    },
    getCoupon(id, callbacks = {}) {
        return { type: Actions.GET_COUPON, id, ...callbacks };
    },
    getCouponLoaded() {
        return { type: Actions.GET_COUPON_LOADED };
    },
    getCouponError(error) {
        return { type: Actions.GET_COUPON_ERROR, error };
    },
    clearCoupon() {
        return { type: Actions.CLEAR_COUPON };
    },
    getCouponApplied(id, callbacks = {}) {
        return { type: Actions.GET_COUPON_APPLIED, id, ...callbacks };
    },
    getCouponAppliedLoaded() {
        return { type: Actions.GET_COUPON_APPLIED_LOADED };
    },
    getCouponAppliedError(error) {
        return { type: Actions.GET_COUPON_APPLIED_ERROR, error };
    },
    sendStarClubTshirtDetails(data, callbacks = {}) {
        return { type: Actions.SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS, data, ...callbacks };
    },
    userLoading(status) {
        return { type: Actions.USER_LOADING, status };
    },
// END OF APP_ACTIONS
});
